import React from "react";
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import { FaExclamationTriangle, FaCheckCircle, FaHourglassHalf } from "react-icons/fa";
import { IconContext } from "react-icons";
import { formatNumberAmount } from "../../helpers/format";
import SimpleBox from "../layout/container/SimpleBox";

const PaymentSummaryItem = ({ paymentSummary, type }) => {

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const amount = paymentSummary.map(k => k.amount).reduce((acc, payment) => acc + payment, 0);
    const formattedAmount = amount ? formatNumberAmount(amount) : " - ";

    const spec = {
        PAID: {text: "Pago", color: "paymentPaid", fontColor: undefined, icon: FaCheckCircle},
        PENDING: {text: "Em falta", color: "paymentMissing", fontColor: "#FFFFFF", icon: FaExclamationTriangle},
        BLANK: {text: "Por Processar", color: "paymentBlank", fontColor: undefined, icon: FaHourglassHalf},
    }[type];
    const IconComponent = spec.icon;

    return (
        <SimpleBox backgroundColor={spec.color} fontColor={spec.fontColor} fullWidth={true} flexDirection="column" padding={2} borderRadius={2}>
            <SimpleBox gap={1}>
            <IconContext.Provider value={{ color: spec.contrastText }}>
                <IconComponent />
            </IconContext.Provider>
            { isMobile ? null : <Typography variant="button" sx={{fontWeight: "bold", marginLeft: theme.spacing(1)}}>{spec.text}</Typography> }
            </SimpleBox>
            <Typography>{formattedAmount}</Typography>
        </SimpleBox>
    )
}

export default PaymentSummaryItem;
